function submitCustomValuesOnMainPage() {
  // Retrieve custom values from localStorage
  var storedcustomFieldValues = localStorage.getItem('customFieldValues');
  var storedcustomMetafieldsValues = localStorage.getItem('customMetafieldsValues');

  if (storedcustomFieldValues && storedcustomMetafieldsValues) {
    // Parse the JSON string
    var customFieldValues = JSON.parse(storedcustomFieldValues);
    var customMetafieldsValues = JSON.parse(storedcustomMetafieldsValues);

    // Check if both customFieldValues and customMetafieldsValues are not null or undefined
    if (customFieldValues && customMetafieldsValues) {
      // Make an AJAX request to your server
      fetch('https://shopify-registration-processor-production.up.railway.app/process-shopify-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ customer: customFieldValues, metafield: customMetafieldsValues}),
      })
      .then(response => response.json())
      .then(data => {
        // Erase the values
        customFieldValues = {};
        customMetafieldsValues = {};
        localStorage.setItem('customFieldValues', JSON.stringify({}));
        localStorage.setItem('customMetafieldsValues', JSON.stringify({}));
      })
      .catch(error => {
        // Erase the values
        customFieldValues = {};
        customMetafieldsValues = {};
        localStorage.setItem('customFieldValues', JSON.stringify({}));
        localStorage.setItem('customMetafieldsValues', JSON.stringify({}));
        console.error('Error:', error);
      });
    } else {
      console.error('customFieldValues or customMetafieldsValues is null or undefined');
      // Handle the case where either customFieldValues or customMetafieldsValues is null or undefined
    }
  }
}

async function updateTrackingCode() {
    return new Promise((resolve) => {
        setTimeout(() => {
            // Retrieve custom values from localStorage
            var orderIds = localStorage.getItem('orderIds');

            if (orderIds) {
                // Parse the JSON string
                var trackingOrderIds = JSON.parse(orderIds);

                // Check if trackingOrderIds is not null or undefined
                if (trackingOrderIds) {
                    // Create a query string from the order IDs
                    const queryString = new URLSearchParams({ orderIds: JSON.stringify(trackingOrderIds) }).toString();

                    // Make an AJAX request to your server
                    fetch(`https://shopify-tracking-code-production.up.railway.app/process-shopify-tracking?${queryString}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        // Erase the values after processing
                        localStorage.setItem('orderIds', JSON.stringify([])); // Clear order IDs
                        resolve(); // Resolve the promise when done
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        // Erase the values on error
                        localStorage.setItem('orderIds', JSON.stringify([])); // Clear order IDs
                        resolve(); // Resolve the promise even on error
                    });
                } else {
                    console.error('trackingOrderIds is null or undefined');
                    resolve(); // Resolve if there are no tracking IDs to process
                }
            } else {
                console.error('No order IDs found in localStorage');
                resolve(); // Resolve if there are no order IDs
            }
        }, 1500); // Simulated delay 
    });
}
